export default "__VITE_ASSET__CNwXA3ps__"